module.exports = __webpack_public_path__ + "media/images/webpage/hotels/4460/floorguide/course-3-photo-6-97d230c516819202a5d41edd8ef75c5f.webp";